import { render } from "./Perkreditan.vue?vue&type=template&id=82377856"
import script from "./Perkreditan.vue?vue&type=script&lang=js"
export * from "./Perkreditan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__